// mui components
import { Checkbox, Typography, Grid } from '@mui/material';

// use form hook
import { Control, Controller, FieldValues, Path } from 'react-hook-form';

interface FormCheckboxProps<T extends FieldValues> {
  name: Path<T>;
  control: Control<T>;
  label: string;
  disabled?: boolean;
}

export const FormCheckbox = <T extends FieldValues>({
  name,
  control,
  label,
  disabled = false,
}: FormCheckboxProps<T>) => {
  return (
    <Grid container>
      <Grid
        item
        xs={12}
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography color="textSecondary">{label}</Typography>
        <Controller
          name={name}
          control={control as Control<FieldValues>}
          render={({ field: { onChange, value } }) => (
            <Checkbox
              disabled={disabled}
              checked={value}
              onChange={(e) => onChange(e.target.checked)}
            />
          )}
        />
      </Grid>
    </Grid>
  );
};
